module.exports = __webpack_public_path__ + "static/media/printing-services-img20.5c9891ff.jpg";